export interface AnnualEIT1000000List {
    row?: string,
    name?: string,
    amount?: string,
    indent?: number,
    rowspan?: number,
    isEdit?: boolean,
    type?: string,
}

let list: AnnualEIT1000000List[] = [
    {
        name: "一、营业收入",
        row: "1",
        amount: "",
        indent: 0,
        isEdit: false,
        type:"利润总额计算",
        rowspan: 13,
    },
    {
        name: "减：营业成本",
        row: "2",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "减：税金及附加",
        row: "3",
        amount: "",
        indent: 2,
        isEdit: true,
    },
    {
        name: "减：销售费用(填写A104000)",
        row: "4",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "减：管理费用(填写A104000)",
        row: "5",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "减：财务费用(填写A104000)",
        row: "6",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "减：资产减值损失",
        row: "7",
        amount: "",
        indent: 2,
        isEdit: true,
    },
    {
        name: "加：公允价值变动收益",
        row: "8",
        amount: "",
        indent: 2,
        isEdit: true,
    },
    {
        name: "加：投资收益",
        row: "9",
        amount: "",
        indent: 2,
        isEdit: true,
    },
    {
        name: "二、营业利润(1-2-3-4-5-6-7+8+9)",
        row: "10",
        amount: "",
        indent: 0,
        isEdit: false,
    },
    {
        name: "加：营业外收入",
        row: "11",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "减：营业外支出",
        row: "12",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "三、利润总额（10+11-12）",
        row: "13",
        amount: "",
        indent: 0,
        isEdit: false,
    },
    {
        name: "减：境外所得（填写A108010）",
        row: "14",
        amount: "",
        indent: 2,
        isEdit: true,
        type:"应纳税所得额计算",
        rowspan:10,
    },
    {
        name: "加：纳税调整增加额（填写A105000）",
        row: "15",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "减：纳税调整减少额（填写A105000）",
        row: "16",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "减：免税、减计收入及加计扣除（填写A107010）",
        row: "17",
        amount: "",
        indent: 2,
        isEdit: true,
    },
    {
        name: "加：境外应税所得抵减境内亏损（填写A108000）",
        row: "18",
        amount: "",
        indent: 2,
        isEdit: true,
    },
    {
        name: "四、纳税调整后所得（13-14+15-16-17+18",
        row: "19",
        amount: "",
        indent: 0,
        isEdit: false,
    },
    {
        name: "减：所得减免（填写A107020）",
        row: "20",
        amount: "",
        indent: 2,
        isEdit: true,
    },
    {
        name: "减：弥补以前年度亏损（填写A106000）",
        row: "21",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "减：抵扣应纳税所得额（填写A107030）",
        row: "22",
        amount: "",
        indent: 2,
        isEdit: true,
    },
    {
        name: "五、应纳税所得额（19-20-21-22）",
        row: "23",
        amount: "",
        indent: 0,
        isEdit: false,
    },
    {
        name: "税率（25%）",
        row: "24",
        amount: "0.25",
        indent: 0,
        isEdit: false,
        type:"应纳税额计算",
        rowspan:13,
    },
    {
        name: "六、应纳所得税额（23×24）",
        row: "25",
        amount: "",
        indent: 0,
        isEdit: false,
    },
    {
        name: "减：减免所得税额（填写A107040）",
        row: "26",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "减：抵免所得税额（填写A107050）",
        row: "27",
        amount: "",
        indent: 2,
        isEdit: false,
    },
    {
        name: "七、应纳税额（25-26-27）",
        row: "28",
        amount: "",
        indent: 0,
        isEdit: false,
    },
    {
        name: "加：境外所得应纳所得税额（填写A108000）",
        row: "29",
        amount: "",
        indent: 2,
        isEdit: true,
    },
    {
        name: "减：境外所得抵免所得税额（填写A108000）",
        row: "30",
        amount: "",
        indent: 2,
        isEdit: true,
    },
    {
        name: "八、实际应纳所得税额（28+29-30）",
        row: "31",
        amount: "",
        indent: 0,
        isEdit: false,
    },
    {
        name: "减：本年累计实际已缴纳的所得税额",
        row: "32",
        amount: "",
        indent: 2,
        isEdit: true,
    },
    {
        name: "九、本年应补（退）所得税额（31-32）",
        row: "33",
        amount: "",
        indent: 0,
        isEdit: false,
    },
    {
        name: "其中：总机构分摊本年应补（退）所得税额(填写A109000)",
        row: "34",
        amount: "",
        indent: 2,
        isEdit: true,
    },
    {
        name: "财政集中分配本年应补（退）所得税额(填写A109000)",
        row: "35",
        amount: "",
        indent: 4,
        isEdit: true,
    },
    {
        name: "总机构主体生产经营部门分摊本年应补（退）所得税额(填写A109000)",
        row: "36",
        amount: "",
        indent: 4,
        isEdit: true,
    }


]


let AnnualEIT1000000 = list
export default AnnualEIT1000000
